import React from 'react';
import { MessageBarType, Stack } from 'office-ui-fabric-react';
import { MessageBar } from '../MessageBar';
import { jsx as _jsx } from "react/jsx-runtime";
export let MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Warning"] = "Warning";
  MessageType["Success"] = "Success";
  MessageType["Error"] = "Error";
  return MessageType;
}({});
export const MessageBarList = props => {
  const {
    maxVisibleCount: maxCount,
    messages,
    messageStyles,
    onCancelMessage,
    testId = 'MessageBar'
  } = props;
  if (!messages.length) {
    return null;
  }
  const getMessageBarType = messageType => {
    switch (messageType) {
      case MessageType.Error:
        return MessageBarType.error;
      case MessageType.Success:
        return MessageBarType.success;
      case MessageType.Warning:
        return MessageBarType.warning;
    }
  };
  return /*#__PURE__*/_jsx(Stack, {
    tokens: {
      childrenGap: 8
    },
    children: messages.slice(0, maxCount).map((message, index) => /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: 'center',
      children: /*#__PURE__*/_jsx(Stack, {
        styles: messageStyles,
        children: /*#__PURE__*/_jsx(MessageBar, {
          messageBarType: getMessageBarType(message.type),
          onDismiss: onCancelMessage ? () => onCancelMessage(index) : undefined,
          "data-id": testId,
          children: message.text
        }, "message-".concat(index))
      })
    }, index))
  });
};